import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  fetchCaseDetailsByCaseIdFail,
  fetchCaseDetailsByCaseIdSuccess,
  FETCH_CASE_DETAILS_BY_CASE_ID
} from '../../redux/actions/cm/caseDetails';

import { fetchCaseDetailsByCaseId } from '../../services/cm/cases';

function* fetchCaseDetailsByCaseIdWorker(caseId) {
  try {
    const caseDetails = yield call(fetchCaseDetailsByCaseId, caseId);

    yield put(fetchCaseDetailsByCaseIdSuccess(caseDetails));
  } catch (error) {
    yield put(fetchCaseDetailsByCaseIdFail(error.message));
  }
}

export function* watchFecthCaseDetailsByCaseId() {
  yield takeEvery(
    FETCH_CASE_DETAILS_BY_CASE_ID,
    function* ({ payload: caseId }) {
      yield fork(fetchCaseDetailsByCaseIdWorker, caseId);
    }
  );
}
